// Carousel.jsx
import React, { useState, useEffect } from 'react';
import './Carousel.css';
import CarouselItem, { Project } from './CarouselItem';
import Button from '../Button';

interface CarouselItemType {
  title: string;
  subtitle: string;
  projects?: Project[];
  [key: string]: any;
}

interface CarouselProps {
  items: CarouselItemType[];
  interval?: number;
  responsiveTracking: number;
}

const Carousel: React.FC<CarouselProps> = ({
  items = [],
  interval = 75000,
  responsiveTracking,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % items.length);
    }, interval);

    return () => clearInterval(timer);
  }, [items.length, interval]);

  const next = () => {
    setCurrentIndex((prev) => (prev + 1) % items.length);
  };

  const prev = () => {
    setCurrentIndex((prev) => (prev - 1 + items.length) % items.length);
  };

  return (
    <div className="carousel">
      <div
        className="carousel-track"
        style={{
          transform: `translateX(-${currentIndex * responsiveTracking}%)`,
        }}
      >
        {items.map((item, index) => (
          <CarouselItem
            key={index}
            item={item}
            projects={item.projects}
            index={index}
            currentIndex={currentIndex}
          ></CarouselItem>
        ))}
      </div>
      <Button className="carousel-btn prev" onClick={prev}>
        &lsaquo;
      </Button>
      <Button className="carousel-btn next" onClick={next}>
        &rsaquo;
      </Button>
    </div>
  );
};

export default Carousel;
